export default __webpack_public_path__ + "static/media/xmashome.6c99b9c6.svg";